import getValueFromPath from '@/core/components/offer/helpers/get-value-from-path';

const OfferAdditionalItem = ({ props }) => {
    const { offer, settings } = props;

    const { value, valueFormatter, visibility } = settings;

    let label = settings.label;

    if (typeof label === 'function') {
        label = label(offer);
    }

    let itemValue = getValueFromPath(offer, value);

    const isVisible = visibility ? visibility(itemValue, offer) : true;

    if (!isVisible) {
        return;
    }

    if (valueFormatter) {
        itemValue = valueFormatter(itemValue, offer);
    }

    return (
        <div class="l-ss-c-offer-content-item">
            <span>{label}</span>
            <span>{itemValue}</span>
        </div>
    );
};

OfferAdditionalItem.props = {
    offer: {
        type: Object,
    },
    settings: {
        type: Object,
    },
};

export default OfferAdditionalItem;
